(function() {
  'use strict';

  /**
   * @ngdoc directive
   * @name webAgro1App.directive:widgetpragasvsaplicacoes
   * @description
   * # widgetpragasvsaplicacoes
   */
  angular
    .module('webAgro1App')
    .directive('widgetPragasVsAplicacoes', WidgetPragasvsAplicacoes);

  /**
   * Declare Widget Pragas vs Aplicações
   * @return {Object}
   */
  function WidgetPragasvsAplicacoes() {

    //////////////////////////////////////////
    // Directive definition object
    var directive = {
      templateUrl: 'views/widgets/pragas-vs-aplicacoes/view.html',
      restrict: 'A',
      controller: 'WidgetPragasvsAplicacoesCtrl',
      controllerAs: 'wctrl',
      scope: {
        widget: '=data'
      }
    };
    return directive;

  }

}());
